import { z } from 'zod';

const grammarAudioClipSchema = z.object({
  audioUrl: z.string(),
});

const grammarPointAudioSchemaDefinition = z.object({
  examples: z.array(
    z.object({
      exampleId: z.number().int(),
      audioUrl: z.string(),
    }),
  ),
  pairRight: grammarAudioClipSchema.optional(),
  pairWrong: grammarAudioClipSchema.optional(),
});

export const grammarPointAudioSchema: typeof grammarPointAudioSchemaDefinition =
  grammarPointAudioSchemaDefinition;

export type IGrammarPointAudio = z.infer<typeof grammarPointAudioSchema>;
